<template>
  <div class="container wc-container" v-if="!isLoading">
  <h3 style="margin-bottom:30px;" >Event Summary Report</h3>
  <Row :gutter="16" style="margin-bottom:24px;">
    <Col :xs="{span: 24, offset: 0}" :sm="{span: 24}" :md="{span: 24}">
      <Select v-model="selectedSession" style="width:400px;">
            <Option v-for="item in sessions" :value="item.id" :key="item.id">{{ item.label }}</Option>
      </Select>
      <Select v-model="reportBy" style="width:200px; margin-left:10px;">
        <Option value="user" default>User</Option>
        <Option value="device">Device</Option>
      </Select>
      <Button type="primary" style="margin-left:10px;" @click="loadReport">Load Report</Button>
    </Col>
  </Row>
  <Row :gutter="16">
    <Col :xs="{span: 24, offset: 0}" :sm="{span: 12}" :md="{span: 6}">
      <Card class="stats-card">
        <div class="stats-number">{{regCount}}</div>
        <div class="stats-title"><b>Registrations</b></div>
        <div><router-link :to="'/wc/'+webcast._id+'/registrations_report'">Registrations Report</router-link></div>
      </Card>
    </Col>

    <Col :xs="{span: 24, offset: 0}" :sm="{span: 12}" :md="{span: 6}">
      <Card class="stats-card">
        <div class="stats-number">{{attCount}}</div>
        <div class="stats-title"><b>Attendees</b></div>
        <div><router-link :to="'/wc/'+webcast._id+'/attendee_report'">Attendees Report</router-link></div>
      </Card>
    </Col>

    <Col :xs="{span: 24, offset: 0}" :sm="{span: 12}" :md="{span: 6}">
      <Card class="stats-card">
        <div class="stats-number">{{avgMinutes}}</div>
        <div class="stats-title"><b>Average View Duration</b></div>
      </Card>
    </Col>

    <Col :xs="{span: 24, offset: 0}" :sm="{span: 12}" :md="{span: 6}">
    <Card class="stats-card">
      <i-circle :percent="attRate" :dashboard="true">
          <span class="demo-Circle-inner" style="font-size:24px">%{{attRate}}</span>
      </i-circle>
      <div class="stats-title"><b>Attendence Conversation Rate</b></div>
      <div class="stats-title">Registrations vs Total Attendees</div>
    </Card>
    </Col>



    <!--
    <Col :xs="{span: 24, offset: 0}" :sm="{span: 12}" :md="{span: 6}">
      <Card class="stats-card">
        <div class="stats-number">{{avgMinutes}}</div>
        <div class="stats-title">Avg. Duration</div>
      </Card>
    </Col>
    -->
  </Row>
  <Row :gutter="16">
    <Col :xs="{span: 24, offset: 0}" :sm="{span: 24}" :md="{span: 24}">
      <ConViewersGraph :session-id="conViewersGraphSessionId"></ConViewersGraph>
    </Col>
  </Row>
  <Row :gutter="16">
    <Col :xs="{span: 24, offset: 0}" :sm="{span: 12}" :md="{span: 12}">
      <Card class="stats-card">
        <canvas id="deviceChart" width="100%"></canvas>
      </Card>
    </Col>
    <Col :xs="{span: 24, offset: 0}" :sm="{span: 12}" :md="{span: 12}">
      <Card class="stats-card">
        <canvas id="locationsChart" width="100%"></canvas>
        <!--
        <div v-for="(value, key) in locations">{{key}} {{value}}</div>
        -->
      </Card>
    </Col>
  </Row>
  </div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'
import moment from 'moment'
import ConViewersGraph from "./ConViewersGraph"
import Chart from 'chart.js';
import $config from '@/config'
import axios from 'axios'

export default {
  components: {
    ConViewersGraph
	},
  data() {
    return {
      isLoading: false,
      aggConnections: [],
      selectedSession: null,
      conViewersGraphSessionId: null,
      reportBy: 'user',
      sessions: {}
    }
  },
  computed: {
    ...mapGetters('webcast', {
      webcast: 'getCopy',
    }),
    ...mapGetters('registrations', {
      findRegistrationsInStore: 'find',
    }),
    ...mapGetters('agg-connections', {
      aggData: 'find',
    }),
    regCount(){
      return this.findRegistrationsInStore({
        query: {
            $limit: 0,
            webcastId: this.webcast._id
        }
      }).total
    },
    attCount(){
      return this.$data.aggConnections.length;
    },
    attRate(){
      if(!this.regCount){
        return 0;
      } else {
        return  _.round((this.attCount*100)/this.regCount,0);
      }
    },
    avgMinutes(){
      let avg_minutes =_.chain(this.$data.aggConnections).meanBy(function(b) { return b.total_duration}).value();
      if(avg_minutes>0){
        return  _.round(avg_minutes/60000,2);
      } else {
        return 0;
      }

    },
    deviceTypes(){
      let devices = []
      devices = _.chain(this.$data.aggConnections).countBy(function(b) { return b.attData.device.type}).value();
      console.log(devices);
      return devices
    },
    locations(){
      let locations = []
      if(this.reportBy == "user"){
        locations = _.chain(this.$data.aggConnections).countBy(function(b) { return b.attData.reg.location}).value();
      } else {
        locations = _.chain(this.$data.aggConnections).countBy(function(b) { return b.attData.device.city}).value();
      }

      return locations;
    }

  },
  watch:{
    aggData(){
      console.log(this.aggData);
    }
  },
  methods: {
    ...mapActions('registrations', {
      findRegistrationsAction: 'find'
    }),
    /* Find hook sends aggrigated session data */
    ...mapActions('agg-connections', {
      aggregateConnectionsAction: 'find'
    }),
    ...mapActions('webcast-session', {
      findSessionAction: 'find'
    }),
    loadReport(){
      this.conViewersGraphSessionId = this.selectedSession;
      this.$store.commit('agg-connections/clearAll');
      let aggregateBy = '$reg._id'

      if(this.reportBy == "device"){
        aggregateBy = '$device._id'
      }

      return this.aggregateConnectionsAction({
        query:{
          webcastId: this.webcast._id,
          sessionId: this.$data.selectedSession,
          aggregateBy: aggregateBy
        }
      }).then((d)=>{
        console.log(this.aggData());
        this.$data.aggConnections = this.aggData().data;
        this.$data.isLoading = false
        setTimeout(()=>{
          console.log("loaded");
          if(d){
            this.devicesChart();
            this.locationsChart();
          }
        },1000);
      });
    },
    devicesChart(){
      let ctx = document.getElementById("deviceChart").getContext('2d');
      let labels = []
      let chartData = []
      let dataTotal = 0;
      _.forEach(this.deviceTypes, (value, key)=>{
        labels.push(key);
        dataTotal = dataTotal + value;
      });

      _.forEach(this.deviceTypes, (value, key)=>{
        chartData.push((value*100)/dataTotal);
      });

      let chart = new Chart(ctx, {
        type: 'doughnut',
        data: {
            labels: labels,
            datasets: [{
                fill: false,
                label: '# Devices',
                data: chartData,
                borderWidth: 1,
                backgroundColor: ["rgb(54, 162, 235)",  "rgb(255, 99, 132)", "rgb(75, 192, 192)", "rgb(153, 102, 255)", "rgb(255, 159, 64)",  "rgb(255, 205, 86)"],
            }]
        }
      });

      console.log(Chart.helpers.color("#222222"));
    },
    locationsChart(){
      let ctx = document.getElementById("locationsChart").getContext('2d');
      let labels = []
      let chartData = []
      let dataTotal = 0;
      _.forEach(this.locations, (value, key)=>{
        labels.push(key);
        chartData.push(value);
      });

      let chart = new Chart(ctx, {
        type: 'horizontalBar',
        data: {
            labels: labels,
            datasets: [{
                fill: false,
                label: '# Locations',
                data: chartData,
                borderWidth: 1,
                backgroundColor: ["rgb(54, 162, 235)",  "rgb(255, 99, 132)", "rgb(75, 192, 192)", "rgb(153, 102, 255)", "rgb(255, 159, 64)",  "rgb(255, 205, 86)"],
            }]
        },
        options: {
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero:true,
              }
            }],
          }
        }
      });
    },
  },

  created(){
    this.$data.isLoading = true
    this.$store.commit('registrations/clearAll');
    this.$store.commit('agg-connections/clearAll');
    this.$store.commit('webcast-session/clearAll');

    this.findRegistrationsAction({
      query:{
        webcastId: this.webcast._id
      }
    });

    this.findSessionAction({query: {
      webcastId: this.webcast._id,
      $sort:{
        createdAt: -1 //Sort by Date Added DESC
      }
    }}).then((sessionList)=>{

      _.forEach(sessionList.data, (s, key)=>{

        let start = moment(s.createdAt).format('LLL');
        let end = ""
        if(s.endAt) {
          end = moment(s.endAt).format('LLL');
        }

        this.$data.sessions[s._id] = {
          id: s._id,
          label: start + ' - ' + end
        };
      });

      this.$data.selectedSession = sessionList.data[0]._id;
      setTimeout(()=>{
        this.loadReport();
      },100);
    });
  },
}
</script>

<style>

</style>
